import { useDashboard, EnvironmentState } from '@wix/dashboard-react';
import { useEnvironment, useWix } from '@wix/sdk-react';
import React from 'react';
import {
  WixPatternsDashboardBaseProvider,
  CairoProviderProps,
} from './CairoDashboardBaseProvider';
import { useEssentials } from '@wix/fe-essentials/react';

export function WixPatternsDashboardProviderInternal(
  props: CairoProviderProps,
) {
  const dashboard = useDashboard();
  const environment = useEnvironment<EnvironmentState>();
  const client = useWix();
  const essentials = useEssentials();

  return (
    <WixPatternsDashboardBaseProvider
      {...props}
      dashboard={dashboard}
      environment={environment}
      client={client}
      essentials={essentials}
    />
  );
}
